export enum ActivityEventEmailOptionsEnum {
  TipoHistorico = 10,
  Titulo = 20,
}
